import router from './router'
import store from './store'
import { Toast } from 'vant'
import { getToken,setToken} from '@/utils/auth' // get token from cookie
import {getUserInfo} from './utils/session'
import {getCodeUrl,getUserAndToken} from '@/api/wechat.js'
import {queryAndUpdateSession} from '@/api/my.js'
import { Dialog } from 'vant';


const whiteList = ['/error','/userform'] // 白名单
/*
把项目中的vant UI组件升级

首先把之前 的VANT 卸载掉
npm uninstall vant

然后重新安装 一次vant
npm i vant -S
*
*
* */
router.beforeEach(async(to, from, next) => {

  console.log("------------------------------from678",from)
  console.log("------------------------------to",to)

  console.log("------------------------------flag",to.query.flag)
  // 设置标题
  document.title = to.meta.title

  // alert(to.path)
  if (whiteList.includes(to.path)) {
    // 在免登录白名单，直接进入
    next()
  }else{
    let token = getToken()
    console.log('token', token)
    if (token&&token!='') {
      let userinfo = JSON.parse(getUserInfo())
      if(to.query.flag){
        console.log("-----------dfsdfdasf------取用户信息过")
        store.dispatch('user/getInfo').then((response)=>{
          console.log("-----------------取用户信息过")
          next()
        })
      }
      console.log("---------------直接过")
      next()
    }else{
      let code = getQueryString("code") // 截取code
      if (!code) {
        console.log('code',code)
        getCodeUrl().then((response) => {
          console.log('response',response.result)
          window.location.href = response.result
        })
      }else{
        console.log('acode',code)
        let data = {};
        data.code = code
        getUserAndToken(data).then((response)=>{
          // alert(response.code)
          if (response.code == 400) {
            Dialog.alert({
              title: '错误提示',
              message: '检查到您还没有关注学员，请到机构处扫码关注学员后再操作，谢谢！',
            }).then(() => {
              WeixinJSBridge.call('closeWindow');
            });
          }else{
            store.dispatch('user/setUserAndToken',response.result)
            console.log("-----------------取用户和token信息过")
            next()
          }
        })
      }
    }
  }
})

router.afterEach(() => {
  Toast.clear()
})


function getQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}


function getQueryURlParams(url,name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = url.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}
